// import { getInvestmentHoldings } from '../../../actions/yodlee';

/*
Not sure how this will look yet but assuming something like:
{
  [ACCOUNT_ID]: investment holdings
}
and it will respond to `getInvestmentHoldings` action
*/
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = arguments.length > 1 ? arguments[1] : undefined,
      type = _ref.type;

  switch (type) {
    default:
      return state;
  }
});